;(function ($, window, document) {
	var $win = $(window)
	var $doc = $(document)
	var scrollHeight
	var cachedScrollPos
	var dateAsString
	var isMobile = null
	var $repositionItem = $('.js-reposition-item')
	var $repositionItemParent = $repositionItem.parent()

	var classes = {
		Hover: 'is-hovered',
		Active: 'is-active',
		ShowNav: 'has-nav-opened',
		Fixed: 'is-fixed',
		Animated: 'is-animated',
		Loaded: 'is-loaded',
	}

	var get = {
		Scroll: 0,
		WinWidth: 0,
	}

	$doc.ready(function () {
		animateOnScroll()
		$win.scrollTop(1)
		$win.scrollTop(0)
	})

	function window_width() {
		var myWidth = 0
		if (typeof window.innerWidth == 'number') myWidth = window.innerWidth
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth
		else if (document.body && document.body.clientWidth) myWidth = document.body.clientWidth
		return myWidth
	}

	function window_height() {
		var myHeight = 0
		if (typeof window.innerHeight == 'number') myHeight = window.innerHeight
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight
		else if (document.body && document.body.clientHeight) myHeight = document.body.clientHeight
		return myHeight
	}

	function animateOnScroll() {
		$('.js-animate').each(function (index, element) {
			var $this = $(element)
			var animateStart = $this.attr('data-start')
			var sectionTop = $this.offset().top
			var sectionHeight = $this.outerHeight()
			var scrollBottom = scrollHeight + $win.outerHeight()
			var sectionStartPosition = sectionHeight * animateStart

			if (sectionTop + sectionStartPosition < scrollBottom) {
				$this.addClass('is-animated')
			}
		})
	}

	function initializeFlickitySliders() {
		var $element = $('.js-slider-flickity')

		if (!$element.length) {
			return false
		}

		$element.each(function () {
			var $slider = $(this)
			var $sliderSlides = $slider.find('.main-carousel')

			// Plugin options

			$sliderSlides.flickity({
				cellAlign: 'left',
				contain: true,
				pageDots: false,
				prevNextButtons: true,
				groupCells: true,
				freeScroll: true,
				draggable: true,
			})
		})
	}

	function initSliderEvents() {
		var $element = $('.js-slider-events')

		if (!$element.length) {
			return false
		}

		$element.each(function () {
			var isFlickity = true
			var $slider = $(this)
			var $sliderSlides = $slider.find('.main-carousel')

			$sliderSlides.flickity({})

			// Plugin options
			if ($win.width() >= 1024 && isFlickity) {
				$sliderSlides.flickity('destroy')
			} else {
				$sliderSlides.flickity({
					cellAlign: 'left',
					contain: true,
					pageDots: false,
					prevNextButtons: true,
					groupCells: false,
					freeScroll: true,
				})
			}
		})
	}

	function initSliderHero() {
		var interleaveOffset = 1

		var swiperOptions = {
			loop: true,
			speed: 1500,
			watchSlidesProgress: true,
			simulateTouch: false,
			loopAdditionalSlides: 0,
			draggable: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.js-slider-hero .swiper-button-next',
				prevEl: '.js-slider-hero .swiper-button-prev',
			},
			pagination: {
				el: '.js-slider-hero .swiper-pagination',
				type: 'bullets',
				clickable: true,
			},

			on: {
				init: function () {
					var swiperEl = this.activeIndex

					setTimeout(function () {
						playPauseVideo(swiperEl, 'play')
						playPauseVimeoVideo(swiperEl, 'play')
					}, 1000)
				},
				progress: function () {
					var swiper = this
					for (var i = 0; i < swiper.slides.length; i++) {
						var slideProgress = swiper.slides[i].progress
						var innerOffset = swiper.width * interleaveOffset
						var innerTranslate = slideProgress * innerOffset
						swiper.slides[i].querySelector('.hero-slider').style.transform =
							'translate3d(' + innerTranslate + 'px, 0, 0)'
					}
				},
				touchStart: function () {
					var swiper = this
					for (var i = 0; i < swiper.slides.length; i++) {
						swiper.slides[i].style.transition = ''
					}
				},
				setTransition: function (speed) {
					var swiper = this
					for (var i = 0; i < swiper.slides.length; i++) {
						swiper.slides[i].style.transition = speed + 'ms'
						swiper.slides[i].querySelector('.hero-slider').style.transition =
							speed + 'ms'
					}
				},
				slideChange: function () {
					var swiperEl = this.activeIndex
					playPauseVideo(swiperEl, 'pause')
					playPauseVimeoVideo(swiperEl, 'pause')
				},
				slideChangeTransitionStart: function () {
					var swiperEl = this.activeIndex
					setTimeout(function () {
						playPauseVideo(swiperEl, 'play')
						playPauseVimeoVideo(swiperEl, 'play')
					}, 500)
				},
			},
		}

		//Make the whole slider a link to the button
		$('.hero-slider').on('click', function () {
			if ($(this).data('link').length > 0) {
				window.location.href = $(this).data('link')
			}
		})

		if ($('.js-slider-hero .swiper-container').length > 0) {
			var swiper = new Swiper('.js-slider-hero .swiper-container', swiperOptions)
		} else if ($('.js-slider-hero .hero__video video').length > 0) {
			var videoEl = $('.js-slider-hero .hero__video video')[0]
			videoEl.play()
		}

		$('.swiper-button-pause').click(function () {
			swiper.autoplay.stop()
			$('.swiper-button-play').removeClass('hidden')
			$(this).addClass('hidden')
		})

		$('.swiper-button-play').click(function () {
			swiper.autoplay.start()
			$('.swiper-button-pause').removeClass('hidden')
			$(this).addClass('hidden')
		})

		function playPauseVideo(swiper, control) {
			var currentSlide, slideType, startTime, player, video

			currentSlide = $('.js-slider-hero').find('.swiper-slide-active')
			player = currentSlide.find('video').get(0)

			if (player != null) {
				if (control === 'play') {
					player.play()
				} else {
					player.pause()
				}
			}
		}

		function postMessageToPlayer(player, command) {
			if (player == null || command == null) return
			player.contentWindow.postMessage(JSON.stringify(command), '*')
		}

		function playPauseVimeoVideo(swiper, control) {
			var currentSlide, slideType, startTime, player, video

			currentSlide = $('.js-slider-hero').find('.swiper-slide-active')
			player = currentSlide.find('iframe').get(0)
			startTime = currentSlide.data('video-start')

			switch (control) {
				case 'play':
					if (startTime != null && startTime > 0 && !currentSlide.hasClass('started')) {
						currentSlide.addClass('started')
						postMessageToPlayer(player, {
							method: 'setCurrentTime',
							value: startTime,
						})
					}
					postMessageToPlayer(player, {
						method: 'play',
						value: 1,
					})
					break
				case 'pause':
					postMessageToPlayer(player, {
						method: 'pause',
						value: 1,
					})
					break
			}
		}
	}

	function initDatepicker() {
		if ($('.js-datepicker').length) {
			var $datepicker = $('.js-datepicker')

			$datepicker.each(function (index, el) {
				var $this = $(this)
				$this.dateRangePicker({
					inline: true,
					container: $this,
					alwaysOpen: true,
					singleMonth: true,
					showTopbar: false,
					hoveringTooltip: false,
					format: 'DD/MM/YYYY',
					startOfWeek: 'monday',
					separator: ' - ',
				})

				$this.dateRangePicker().bind('datepicker-change', function (event, obj) {
					$this
						.parent()
						.closest('.js-filter-dropdown-nav')
						.siblings()
						.find('.dropdown__selection')
						.text(obj.value)
						.prev()
						.text('')

					$this
						.parent()
						.closest('.js-filter-dropdown-nav')
						.find('li:last-of-type')
						.addClass('is-active')
						.siblings()
						.removeClass('is-active')

					$this
						.parent()
						.closest('.js-filter-dropdown-nav')
						.find('li:last-of-type .datepicker-holder')
						.data('id', obj.value)
				})
			})
		}
	}

	function dropdownInit() {
		$('.js-dropdown-filter').each(function (index, el) {
			var $this = $(this)

			$this.find('.js-dropdown-field').on('click', function () {
				$(this)
					.toggleClass('is-active')
					.siblings('.js-filter-dropdown-nav')
					.slideToggle()
					.parent()
					.siblings()
					.find('.js-dropdown-field')
					.removeClass('is-active')
					.siblings()
					.slideUp()

				$(this).closest('.tab').find('.tab__inner').addClass('is-active')

				// animateOnScroll()
			})

			$this.find('.js-filter-dropdown-nav a').on('click', function (event) {
				event.preventDefault()
				$(this).parent().addClass('is-active').siblings().removeClass('is-active')

				var value = $(this).text()

				$this.find('.dropdown__selection').text(value).prev().text('')
			})
		})

		$('.js-btn-submit-filter').on('click', function (event) {
			event.preventDefault()
			$(this).closest('.tab').find('.tab__inner').removeClass('is-active')

			$('.js-filter-dropdown-nav').slideUp()

			$('.js-dropdown-field').removeClass('is-active')

			if ($('body').hasClass('is-kp-whats-on')) {
				const $Rows = $(this).prev().find('.section__filter-row')
				getEventsFilters($Rows, false, null)
			} else if ($(window).outerWidth() >= 768) {
				const $Rows = $(this).prev().find('.hidden-xs')
				getEventsFilters($Rows, false, $(this).closest('.tab').attr('id'))
			} else {
				const $Rows = $(this).prev().find('.hidden-lg')
				getEventsFilters($Rows, true, $(this).closest('.tab').attr('id'))
			}
		})

		$('.tab__inner').on('click', function () {
			if ($(this).hasClass('is-active')) {
				$(this).removeClass('is-active')

				$('.js-filter-dropdown-nav').slideUp()

				$('.js-dropdown-field').removeClass('is-active')
			}
		})
	}

	function eventTabs() {
		var activeTabClass = 'is-current'
		$('.event__tabs a, a[href="#event-details-mobile"]').on('click', function (event) {
			event.preventDefault()

			var $tabLink = $(this)
			var $targetTab = $($tabLink.attr('href'))

			var $tabParent = $tabLink.parent()

			if ($tabParent[0].nodeName != 'LI') {
				$tabParent = $('.event-single .event__tabs li:nth-of-type(2)')
			}

			$tabParent
				.add($targetTab)
				.addClass(activeTabClass)
				.siblings()
				.removeClass(activeTabClass)

			$('html, body').animate(
				{
					scrollTop: $('.section-event').offset().top - 40,
				},
				500
			)

			if ($('#event-details-mobile').hasClass('is-current')) {
				$('.section-default--gallery').addClass('hidden')
				$('.section-events').addClass('hidden')
			} else {
				$('.section-default--gallery').removeClass('hidden')
				$('.section-events').removeClass('hidden')
			}
		})
	}

	function initTabs() {
		var activeTabClass = 'is-current'

		$('.tabs__nav a').on('click', function (event) {
			event.preventDefault()

			var $tabLink = $(this)
			var $targetTab = $($tabLink.attr('href'))

			if (window.location.search == '') {
				$tabLink
					.parent()
					.add($targetTab)
					.addClass(activeTabClass)
					.siblings()
					.removeClass(activeTabClass)

				initializeFlickitySliders()
			} else {
				window.location.search = 'tab=' + $targetTab[0].id
			}
		})
	}

	function initMap() {
		$('#map').each(function (index, Element) {
			var center = $(this).data('center')

			var myOptions = {
				zoom: 17,
				center: center,
			}

			var map = new google.maps.Map(Element, myOptions)

			var marker = new google.maps.Marker({
				position: center,
				map: map,
				icon: {
					url: '/performing-arts-centres/wp-content/themes/mpac/assets/dist/images/ico-pin.svg',
					scaledSize: new google.maps.Size(45, 69),
				},
			})

			google.maps.event.addDomListener(window, 'resize', function () {
				map.setCenter(center)
			})
		})
	}

	function hoverEvents() {
		$('.js-events').each(function (index, el) {
			var $this = $(this)
			var $eventsItems = $this.find('.events__item')
			var n = 0
			var i = 1
			var k = 0

			if ($win.width() < 1200) {
				n = $this.attr('data-row-items-min')
			} else if ($win.width() > 1600) {
				n = $this.attr('data-row-items-max')
			} else if ($win.width() <= 1600) {
				n = $this.attr('data-row-items')
			}

			var $parent = $this

			$eventsItems.each(function () {
				var $this = $(this)
				var defaultWidth = 90 / n
				var hoveredWidht = defaultWidth + 10
				var fontSizeWidth = 30
				var fontSizeWidthDec = fontSizeWidth * 0.1
				$this.attr('data-row', i)
				if ($this.attr('data-promo') == 2) {
					k++
				}

				var $eventSubtitle = $parent
					.find('.events__item[data-row="' + $(this).attr('data-row') + '"]')
					.find('.event__subtitle')

				if ($eventSubtitle.length) {
					$(this)
						.siblings('.events__item[data-row="' + $(this).attr('data-row') + '"]')
						.addClass('events__item--subtitle')

					$(this).addClass('events__item--subtitle')
				} else {
					$(this)
						.siblings('.events__item[data-row="' + $(this).attr('data-row') + '"]')
						.removeClass('events__item--subtitle')
					$(this).removeClass('events__item--subtitle')
				}
				if (k % n === n - 1) {
					i++
				}
				k++
			})
		})
	}

	function popupSignup() {
		var expirationDuration = 1000 * 60 * 60 * 8 // 24 hours
		var currentTime = new Date().getTime()
		var lastVistited = localStorage.getItem('popup-subscribe-3-last-visited')
		var poppy = localStorage.getItem('popup-subscribe-3')
		var notVisited = lastVistited == undefined
		var lastVistitedExpired =
			lastVistited != undefined && currentTime - lastVistited > expirationDuration

		if (notVisited || lastVistitedExpired) {
			function PopUp() {
				$('.js-popup-home').addClass('is-visible')
				$('.js-popup').addClass('is-visible')
			}

			setTimeout(function () {
				PopUp()
				localStorage.setItem('popup-subscribe-3', 'true')
				localStorage.setItem('popup-subscribe-3-last-visited', currentTime)
			}, 30000) // 1000 to load it after 1 second from page load
		}
	}

	function stuckButton(winST) {
		if (!$('.js-btn-book-fixed').length) {
			return
		}

		var $this = $('.js-btn-book-fixed')

		var stuckCondition =
			winST + $('header.header').outerHeight() >
			$this.closest('.js-section-btn .section__head').offset().top +
				$this.closest('.js-section-btn .section__head').outerHeight() -
				$this.outerHeight()

		if (stuckCondition) {
			$('.js-btn-book-inner').addClass('is-active')
		} else {
			$('.js-btn-book-inner').removeClass('is-active')
		}
	}

	function stuckButtonEvent(winST) {
		if (!$('.js-btn-event-fixed').length) {
			return
		}

		var $this = $('.js-btn-event-fixed')

		var stuckCondition =
			winST + $('.header__outer').outerHeight() >
			$this.closest('.js-section-btn-event .event__group--size-3').offset().top +
				$this.closest('.js-section-btn-event .event__group--size-3').outerHeight() -
				$this.outerHeight()

		if (stuckCondition) {
			$('.js-btn-event-inner').addClass('is-active')
		} else {
			$('.js-btn-event-inner').removeClass('is-active')
		}
	}

	function initSelect() {
		const $select = $('.js-select select')
		if (!$select.length) {
			return false
		}

		$select.each(function () {
			$(this).selectric({})
		})

		$('.js-select').each(function () {
			var $labelText = $(this).find('label')

			$labelText.insertBefore($(this).find('.selectric .label'))
		})
	}

	function initGformSelect() {
		const $select = $('.gfield_select')
		if (!$select.length) {
			return false
		}

		$select.each(function () {
			$(this).selectric({})
		})

		$('.js-select').each(function () {
			var $labelText = $(this).find('label')

			$labelText.insertBefore($(this).find('.selectric .label'))
		})
	}

	$.fn.equalizeHeight = function () {
		var maxHeight = 0,
			itemHeight

		this.height('')

		for (var i = 0; i < this.length; i++) {
			itemHeight = $(this[i]).height('auto').height()
			if (maxHeight < itemHeight) {
				maxHeight = itemHeight
			}
		}

		return this.height(maxHeight)
	}

	function truncate(container) {
		const $shave = $('.shave-entry')
		const $shaveContent = $shave.find('.shave-content')

		let truncateValue

		if ($win.width() > 767 && container.attr('data-truncate')) {
			truncateValue = parseInt(container.attr('data-truncate'))
		} else if ($win.width() < 768 && container.attr('data-truncate-mobile') != '') {
			truncateValue = parseInt(container.attr('data-truncate-mobile'))
		} else {
			truncateValue = ''
		}

		if (truncateValue <= container.height()) {
			container.closest('.container').find('.js-read-more').addClass('d-none')
		}

		if ($shaveContent.height() < truncateValue) {
			container.css({
				height: $shaveContent.height(),
				overflow: 'hidden',
			})
			container.closest('.container').find('.js-read-more').addClass('d-none')
		} else {
			container.css({ height: truncateValue, overflow: 'hidden' })
		}
	}

	function stickySidebar() {
		var sidebar = $('.js-fixed-element').stickySidebar({
			containerSelector: '.js-fixed-on-scroll',
			topSpacing: 64,
			bottomSpacing: 0,
		})

		if ($win.width() < 1024) {
			$('.js-fixed-element').stickySidebar('destroy')
		}
	}

	function stickySidebarEvent() {
		let $fixedElement = $('.js-event-fixed-on-scroll')
		let $fixedElementDetails = $fixedElement.find('.event__details-inner')
		let $fixedElementDetailsHeight = $fixedElementDetails.outerHeight()
		let additionalSpace = $fixedElement.data('offset') || 0
		let $fixedElementChild = $('.js-event-fixed-element')
		let headerHeight = $('.header__bar').outerHeight()
		let fixedElementOffsetTop, fixedElementH, fixedElementChildH
		let btnInner = $('.js-btn-event-inner hi').outerHeight()

		$win.on('resize load scroll', function () {
			let $fixedElementChildWidth = $fixedElementChild.innerWidth()
			let $fixedElementChildHeight = $fixedElementChild.outerHeight()
			if ($fixedElementChildHeight < $fixedElementDetailsHeight) {
				if ($fixedElement.length) {
					fixedElementOffsetTop = $fixedElement.offset().top
					fixedElementH = $fixedElement.outerHeight()
					fixedElementChildH = $fixedElementChild.outerHeight()

					let scroll = $(this).scrollTop()

					if (scroll > fixedElementOffsetTop - headerHeight) {
						$fixedElement.addClass('is-fixed')
						if ($win.width() >= 1023) {
							$fixedElementChild.width($fixedElementChildWidth - 62)
						}
					} else {
						$fixedElement.removeClass('is-fixed')
						$fixedElementChild.css({
							width: 'auto',
						})
					}

					if (
						scroll >
						fixedElementOffsetTop +
							fixedElementH -
							additionalSpace -
							fixedElementChildH -
							headerHeight
					) {
						$fixedElement.addClass('at-bottom')
					} else {
						$fixedElement.removeClass('at-bottom')
					}
				}
			}
		})
	}

	function initAccordions() {
		var $accordion = $('.js-accordion')
		$('.accordion__section').not('.is-current').find('.accordion__body').hide()

		$accordion.on('click', '.accordion__head', function (event) {
			const $accordionSection = $(this).closest('.accordion__section')
			const $accordionBody = $accordionSection.find('.accordion__body')

			$accordionBody.stop().slideToggle()

			$accordionSection.toggleClass('is-current')
		})
	}

	function stopVideo() {
		var $frame = $('.embed-player')

		// saves the current iframe source
		var vidsrc = $frame.attr('src')

		// sets the source to nothing, stopping the video
		$frame.attr('src', '')

		// sets it back to the correct link so that it reloads immediately on the next window open
		$frame.attr('src', vidsrc)
	}

	$('.js-popup').on('click', function (e) {
		e.preventDefault()

		var $this = $(this)

		$($this.data('target')).toggleClass('is-visible')
		if (!$($this.data('target')).hasClass('is-visible')) {
			stopVideo()
		}
	})

	$('.js-btn-search').on('click', function (e) {
		e.preventDefault()

		var $searchLink = $(this)
		var $targetSearchBlock = $($searchLink.attr('href'))

		$targetSearchBlock.toggleClass('is-active')
		cachedScrollPos = $win.scrollTop()
		$('body').addClass('is-fixed')
		$('body').css('top', -cachedScrollPos)
	})

	$('.js-search-popup-close').on('click', function (event) {
		event.preventDefault()
		$('.popup-search').removeClass('is-active')
		$('body').removeClass('is-fixed')
		$('body').css('top', 'auto')
		window.scrollTo(0, cachedScrollPos)
	})

	$('.nav-trigger-open').on('click', function (event) {
		event.preventDefault()
		var $trigger = $(this)

		cachedScrollPos = $win.scrollTop()
		$('body').addClass('is-fixed')
		$('body').css('top', -cachedScrollPos)

		if ($trigger.hasClass('kp-nav-trigger--open')) {
			$trigger.addClass('is-active')
			$('.js-header-bar').addClass('is-active')
			$('.kp-header__menu').attr('aria-hidden', 'false')
		} else {
			$('.js-header-bar').addClass('is-active')
		}
	})

	$('.nav-trigger-close').on('click', function (event) {
		event.preventDefault()
		$('.js-header-bar').removeClass('is-active')
		$('.kp-header__menu').attr('aria-hidden', 'true')
		$('.kp-nav-trigger--open').removeClass('is-active')
		$('body').removeClass('is-fixed')
		$('body').css('top', 'auto')
		window.scrollTo(0, cachedScrollPos)
	})

	function setKpHeaderHeight() {
		var $kpHeader = $('.kp-header__inner')

		if (!$kpHeader.length) {
			return
		}

		document.documentElement.style.setProperty(
			'--kp-header-height',
			$kpHeader.outerHeight() + 'px'
		)
	}

	function updateKpHero() {
		var $hero = $('.js-kp-hero').first()
		var $header = $('.kp-header--over-hero')
		var lightLogoOnly = $header.hasClass('kp-header--light-logo-only')

		if (!$hero.length) {
			return
		}

		var heroTop = $hero.offset().top
		var heroHeight = $hero.outerHeight() - window_height()
		var progress = 0

		if (heroHeight > 0) {
			progress = Math.min(Math.max(($win.scrollTop() - heroTop) / heroHeight, 0), 1)
		}

		$hero[0].style.setProperty('--kp-hero-progress', progress)

		if ($header.length) {
			var isOverHero = $win.scrollTop() < heroTop + $hero.outerHeight()

			$header[0].style.setProperty('--kp-header-hero-progress', progress)
			$header.toggleClass('is-over-kp-hero', isOverHero)
			$header.toggleClass('is-over-kp-hero-active', isOverHero && progress > 0.08)

			if (lightLogoOnly) {
				$header.addClass('kp-header--light-logo-only')
			}
		}
	}

	$('.js-kp-hero-volume').on('click', function () {
		var $button = $(this)
		var video = $button.closest('.js-kp-hero').find('.js-kp-hero-video').get(0)

		if (!video) {
			return
		}

		video.muted = !video.muted
		$button.toggleClass('is-unmuted', !video.muted)
		$button.attr('aria-label', video.muted ? 'Unmute video' : 'Mute video')
	})

	$('.kp-nav a').on('mouseenter', function () {
		$('.kp-menu-cursor').addClass('is-active')
	})

	$('.kp-nav a').on('mouseleave', function () {
		$('.kp-menu-cursor').removeClass('is-active')
	})

	$('.kp-nav a').on('mousemove', function (event) {
		$('.kp-menu-cursor').css({
			left: event.clientX,
			top: event.clientY,
		})
	})

	setKpHeaderHeight()
	$win.on('load resize', setKpHeaderHeight)
	updateKpHero()
	$win.on('load resize scroll', updateKpHero)

	function updateKpFormFields() {
		$('.kp-footer__form .gfield input, .kp-footer__form .gfield textarea, .kp-footer__form .gfield select').each(function () {
			var $field = $(this).closest('.gfield')

			if ($(this).is(':focus')) {
				return
			}

			$field.toggleClass('is-filled', !!$(this).val())
		})
	}

	$doc.on('blur change', '.kp-footer__form .gfield input, .kp-footer__form .gfield textarea, .kp-footer__form .gfield select', updateKpFormFields)
	$doc.on('gform_post_render gform_page_loaded', updateKpFormFields)
	updateKpFormFields()

	function initKpAocPopup() {
		var $popup = $('.js-kp-aoc-popup')
		var shouldForce = window.location.search.indexOf('showKpPopup') !== -1
		var storageKey = 'kpAocPopupShown'
		var hasShown = false

		if (!$popup.length) {
			return
		}

		try {
			hasShown = window.sessionStorage.getItem(storageKey) === '1'
		} catch (error) {
			hasShown = false
		}

		if (!shouldForce && hasShown) {
			return
		}

		setTimeout(function () {
			cachedScrollPos = $win.scrollTop()
			$('body').addClass('is-fixed')
			$('body').css('top', -cachedScrollPos)
			$popup.addClass('is-active').attr('aria-hidden', 'false')
		}, 50)
	}

	function closeKpAocPopup($popup) {
		$popup.removeClass('is-active').attr('aria-hidden', 'true')
		$('body').removeClass('is-fixed')
		$('body').css('top', 'auto')
		window.scrollTo(0, cachedScrollPos)

		try {
			window.sessionStorage.setItem('kpAocPopupShown', '1')
		} catch (error) {}
	}

	$('.js-kp-aoc-popup-close').on('click', function () {
		closeKpAocPopup($(this).closest('.js-kp-aoc-popup'))
	})

	$('.js-kp-aoc-popup').on('click', function (event) {
		if (event.target !== this) {
			return
		}

		closeKpAocPopup($(this))
	})

	initKpAocPopup()

	$('.js-btn-scroll-top').on('click', function (e) {
		e.preventDefault()

		$('html, body').animate(
			{
				scrollTop: 0,
			},
			2000
		)
	})

	$('.js-scroll-btn').on('click', function (e) {
		e.preventDefault()
		var target = $(this).attr('href')
		var $target = $(target)

		if (!$target.length) {
			return
		}

		var headerHeight = $('.kp-header:visible, .header:visible').first().outerHeight() || 0

		$('html, body').animate(
			{
				scrollTop: Math.max($target.offset().top - headerHeight, 0),
			},
			2000
		)
	})

	var stickyOffset = $('.js-header-bar').offset().top
	var stickyOffsetMobile = $('.js-header-inner-holder').offset().top
	if ($('.js-sticky-bar').length) {
		var stickyOffsetBar = $('.js-sticky-bar').offset().top
	}

	$win.on('resize load scroll', function () {
		scrollHeight = $win.scrollTop()

		animateOnScroll()

		var sticky = $('.js-header-bar')
		var stickyBar = $('.js-sticky-bar')
		var stickyMobile = $('.js-header-inner-holder')
		var scroll = $(window).scrollTop()

		if (scroll >= stickyOffset && $win.width() > 1024) sticky.addClass('is-fixed')
		else sticky.removeClass('is-fixed')

		if ($('.alert').length) {
			if (scroll >= stickyOffsetMobile && $win.width() < 1024)
				stickyMobile.addClass('is-fixed')
			else stickyMobile.removeClass('is-fixed')
		} else {
			if (scroll > 0 && $win.width() < 1024) stickyMobile.addClass('is-fixed')
			else stickyMobile.removeClass('is-fixed')
		}

		if (stickyBar.length) {
			if (scroll >= stickyOffsetBar - 42) stickyBar.addClass('is-fixed')
			else stickyBar.removeClass('is-fixed')
		}
	})

	function repositionItem($item) {
		var target = $item.data('target')
		var position = $item.data('position')
		var $parent = $item.parent()

		if ($item.attr('data-position')) {
			if (position === 'bottom') {
				$item.appendTo($(target))
			} else {
				$item.prependTo($(target))
			}
		}
	}

	function mobileLayout() {
		if ($win.width() < 1024) {
			if (isMobile) {
				return
			}

			isMobile = true

			$repositionItem.each(function () {
				repositionItem($(this))
			})
		} else {
			if (isMobile === false) {
				return
			}

			$repositionItem.prependTo($repositionItemParent)

			isMobile = false
		}
	}

	function videoPopup() {
		$('.js-popup-video').each(function (index, el) {
			$(this).magnificPopup({
				disableOn: 700,
				type: 'iframe',
				mainClass: 'mfp-fade',
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false,
			})
		})
	}

	function sectionEventsPadding() {
		$('.section-events-alt').each(function (index, el) {
			var $this = $(this)

			if ($this.hasClass('kp-whats-on')) {
				$this
					.find('.js-advanced-search')
					.off('click.kpWhatsOn')
					.on('click.kpWhatsOn', function (e) {
						e.preventDefault()
						$this.find('.js-filter-row-advanced').toggleClass('is-active')
					})

				$this.css({
					paddingTop: '0',
				})

				return
			}

			var $sectionFilter = $this.find('.section__filter')
			var sectionFilterHeight = $sectionFilter.outerHeight()
			var $advancedSearch = $this.find('.js-advanced-search')
			var $advancedSearchRow = $this.find('.js-filter-row-advanced')
			var $advancedSearchRowMobile = $this.find('.js-advanced-mobile')

			if ($win.width() > 767) {
				$this.css({
					paddingTop: sectionFilterHeight,
				})
			} else {
				$this.css({
					paddingTop: '0',
				})
			}

			$advancedSearch.on('click', function (e) {
				e.preventDefault()
				if ($win.width() > 767) {
					$advancedSearchRow.toggleClass('is-active')
					var sectionFilterHeightUpdated = $sectionFilter.outerHeight()
					$this.css({
						paddingTop: sectionFilterHeightUpdated,
					})
				} else {
					$advancedSearchRowMobile.toggleClass('is-active')
				}
			})
		})
	}

	$('.menu-item-has-children').on('mouseover', function () {
		$('.wrapper').addClass('is-active')
	})

	$('.menu-item-has-children').on('mouseout', function () {
		$('.wrapper').removeClass('is-active')
	})

	$win.on('load resize', function () {
		initSliderEvents()
		stickySidebar()
		stickySidebarEvent()
		hoverEvents()
		$('.plan .plan__content').equalizeHeight()

		$('.js-read-more')
			.off()
			.on('click', function (e) {
				e.preventDefault()

				const $this = $(this)
				const $shave = $this.closest('.js-truncate-container').find('.shave-entry')
				const $entry = $shave.find('.shave-content')
				const heightEntry = $entry.height()

				let shaveHeight

				if ($win.width() < 768) {
					shaveHeight = $shave.data('truncate-mobile')
				} else {
					shaveHeight = $shave.data('truncate')
				}

				if ($this.hasClass('active')) {
					$shave.animate({
						height: shaveHeight,
					})

					$this.removeClass('active')

					$this.find('span').text('Read more')
				} else {
					$this.toggleClass('active')

					$shave.animate({
						height: heightEntry,
					})

					$this.find('span').text('Read less')
				}
			})

		if ($win.width() < 1023) {
			$('.sub-menu').slideUp()
			$('.menu-item-has-children > a')
				.off()
				.one('click', function (e) {
					e.preventDefault()

					$(this).siblings('.sub-menu').slideToggle().parent().toggleClass('is-expanded')
				})
		} else {
			$('.sub-menu').slideDown()
		}

		mobileLayout()
		sectionEventsPadding()
	})

	$win.on('load scroll resize', function () {
		get.Scroll = $win.scrollTop()
		stuckButton(get.Scroll)

		if ($win.width() > 1024) {
			stuckButtonEvent(get.Scroll)
		}
	})
	if ($win.width() < 768) {
		$('.js-events-filter').slideUp()
	}

	$win.on('load', function () {
		stickySidebarEvent()
		initSliderHero()
		initializeFlickitySliders()
		initDatepicker()
		initMap()
		$('.tooltip').tooltip({
			position: {
				my: 'center bottom-10',
				at: 'center top',
				using: function (position, feedback) {
					$(this).css(position)
					$('<div>')
						.addClass('ico-arrow-tooltip')
						.addClass(feedback.vertical)
						.addClass(feedback.horizontal)
						.appendTo(this)
				},
			},
		})

		$('[data-truncate]').each(function () {
			truncate($(this))
		})

		if ($win.width() < 768) {
			$('[data-truncate-mobile]').each(function () {
				truncate($(this))
			})
		}

		if ($win.width() < 768) {
			$('.js-events-filter').slideUp()
			$('.js-open-events-filter').each(function (index, el) {
				$(this)
					.off()
					.on('click', function (event) {
						event.preventDefault()
						$(this).toggleClass('is-active').siblings('.js-events-filter').slideToggle()
					})
			})
		} else {
			$('.js-events-filter').slideDown()
		}

		$('[data-check-status-uri]').each(function () {
			var $thisObj = $(this),
				url = $(this).attr('data-check-status-uri')
			if ($thisObj.find('.event__image-tag-from-api').length > 0 && url.length > 0) {
				$.ajax({
					type: 'GET',
					url: url,
					dataType: 'json',
					success: function (response) {
						var jsonResponse = response[0]
						var $tag = $thisObj.find('.event__image-tag-from-api')
						if (jsonResponse.sellingStatus.length > 0)
							$tag.html(jsonResponse.sellingStatus).removeClass('hidden')
					},
				})
			}
		})
	})

	$('.section-contact .gform_wrapper textarea').focus(function () {
		$(this).parents('.gfield').addClass('is-focused')
	})

	$('.form-enquiry .gform_wrapper textarea').blur(function () {
		var inputValue = $(this).val()
		if (inputValue === '') {
			$(this).parents('.gfield').removeClass('is-filled')
			$(this).parents('.gfield').removeClass('is-focused')
		} else {
			$(this).addClass('is-filled')
			$(this).parents('.gfield').removeClass('is-focused')
			$(this).parents('.gfield').addClass('is-filled')
		}
	})

	/*$('.form .gform_wrapper textarea').focus(function() {
		$(this)
			.parents('.gfield')
			.addClass('is-focused');
	});

	$('.form .gform_wrapper textarea').blur(function() {
		var inputValue = $(this).val();
		if (inputValue === '') {
			$(this)
				.parents('.gfield')
				.removeClass('is-filled');
			$(this)
				.parents('.gfield')
				.removeClass('is-focused');
		} else {
			$(this).addClass('is-filled');
			$(this)
				.parents('.gfield')
				.removeClass('is-focused');
			$(this)
				.parents('.gfield')
				.addClass('is-filled');
		}
	});*/

	$doc.on('gform_post_render', function (event, form_id, current_page) {
		$('.gform_footer').each(function (index, el) {
			var $this = $(this)

			if (!$this.find('> span').length) {
				var $formButton = $this.find('.gform_button')
				var $buttonText = $formButton.val()
				$this.append('<span>' + $buttonText + '</span>')
			}
		})
	})

	$doc.on('click', function (e) {
		if (!$('.js-popup').is(e.target) && $('.js-popup').has(e.target).length === 0) {
			$('.popup-video').removeClass('is-visible')
			stopVideo()
		}
	})

	$doc.ready(function ($) {
		initTabs()
		dropdownInit()
		eventTabs()
		initSelect()
		initGformSelect()
		initAccordions()
		popupSignup()
		stickySidebarEvent()
		$('.datepicker').datepicker({
			dateFormat: 'dd/mm/yy',
		})
		videoPopup()
	})

	// Integration
	function setCookie(cname, cvalue, exdays) {
		var d = new Date()
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
		var expires = 'expires=' + d.toUTCString()
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
	}

	function getCookie(cname) {
		var name = cname + '='
		var ca = document.cookie.split(';')
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i]
			while (c.charAt(0) == ' ') {
				c = c.substring(1)
			}

			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length)
			}
		}

		return ''
	}

	$doc.ready(function ($) {
		if ($('.alert').length) {
			if (getCookie('_efront_is_alert_sawn') === 'yes') {
				$('.alert').remove()
			}
		}
	})

	$('.alert .alert__close').on('click', function (e) {
		e.preventDefault()

		$('.alert').remove()
		setCookie('_efront_is_alert_sawn', 'yes', 1)
	})

	function getEventsFilters($Rows, isMobile, tab) {
		// const data = [];
		let url = window.location.origin + window.location.pathname

		if ($('body').hasClass('is-kp-whats-on')) {
			url += '?'
		} else {
			url = url.split('whats-on')[0]
			url += 'whats-on/' + tab + '/?'
		}

		if (!isMobile) {
			// Desktop Submit
			$Rows.find('.dropdown-filter .is-active').each(function (key, elem) {
				const fieldName = $(elem).parent().data('name')
				let fieldValue = $(elem).find('a').data('id')

				// DatePicker
				if (fieldName === 'date' && !fieldValue) {
					const $DateField = $(elem).find('.datepicker-holder')

					const dates = $DateField.data('id').split(' - ')

					const dateFrom = dates[0].replace(/\//g, '-')
					const dateTo = dates[1].replace(/\//g, '-')

					url += 'date=' + dateFrom + '&'
					url += 'date_to=' + dateTo + '&'
				} else if (fieldName == 'price') {
					const priceMin = $(elem).find('a').data('min')
					const priceMax = $(elem).find('a').data('max')

					url += 'price_min=' + priceMin + '&'
					url += 'price_max=' + priceMax + '&'
				} else {
					url += fieldName + '=' + fieldValue + '&'
				}

				// data[ fieldName ] = fieldValue;
			})

			window.location.href = url.slice(0, -1)
			// could send data as ajax..
		} else {
			// Mobile Submit
			$Rows.find('.selected').each(function (key, elem) {
				const $Select = $(elem).parents('.selectric-wrapper').find('select')
				const fieldName = $Select.attr('name').replace('field-', '')
				let fieldValue = $Select.val()

				if (!fieldValue.length) {
					return
				}

				// DatePicker
				if (fieldName === 'date' && !fieldValue) {
					const $DateField = $(elem).find('.datepicker-holder')

					const year = $DateField.data('year')
					const month = $DateField.data('month') + 1
					const day = $DateField.text().trim()

					fieldValue = month + '-' + day + '-' + year
				}

				if (fieldName == 'price') {
					const priceMin = $(elem).find('a').data('min')
					const priceMax = $(elem).find('a').data('max')

					url += 'price_min=' + priceMin + '&'
					url += 'price_max=' + priceMax + '&'
				} else {
					url += fieldName + '=' + fieldValue + '&'
				}

				// data[ fieldName ] = fieldValue;
			})

			window.location.href = url.slice(0, -1)
		}
	}

	// Gravity Forms
	/*
	$(window).on('load', function () {
		if ($('.section-contact .gform_wrapper').length) {
			$('.section-contact .gform_wrapper .gform_next_button').trigger('click')
			$('input[name^="gform_target_page_number_"]').val('0')
		}
	})
	*/

	// Plan Your Visit !!TBD!!
	$('body').on('click', '.js-search-plans', function (e) {
		e.preventDefault()

		let venue = $('body').find('#field-venue').val()
		let mode = $('body').find('#field-mode').val()
		let date = $('body').find('#field-date').val()
		// ? $('body').find('#field-date').val()
		// : 'non-selected'
		let time = $('body').find('#field-time').val()
		// ? $('body').find('#field-time').val()
		// : 'non-selected'

		// console.log('venue: ' + venue)
		// console.log('mode: ' + mode)
		// console.log('date: ' + date)
		// console.log('time: ' + time)

		if (venue && !mode && !date && !time) {
			mode = 'non-selected'
			date = 'non-selected'
			time = 'non-selected'
		}

		let link = $(this).attr('href')

		link += '?_venue=' + venue

		link += mode && mode.length ? '&_transport=' + mode : ''
		link += date && date.length ? '&_dates=' + date : ''
		link += time && time.length ? '&_times=' + time : ''

		window.location.href = link
	})

	$('body').on('click', '.js-clear-plan', function (e) {
		e.preventDefault()
		$(this).parents('.plans').find('select').val('').selectric('refresh')
		$('.plans__actions').addClass('disabled')
	})

	$('body').on(
		'change',
		'.plans select[name="field-venue"], .plans select[name="field-mode"], .plans select[name="field-date"], .plans select[name="field-time"]',
		function (e) {
			var venue = $('.plans select[name="field-venue"]')[0].value
			var mode = $('.plans select[name="field-mode"]')[0].value
			var date = $('.plans select[name="field-date"]')[0].value
			var time = $('.plans select[name="field-time"]')[0].value

			if (venue && mode && date && time) {
				$('.plans__actions').toggleClass('disabled', !$(this).val().length)
			}
		}
	)

	// Behind The Scenes
	$('body').on('click', '.js-filter-news', function (e) {
		e.preventDefault()

		const category = $('body').find('select[name="field-filter"]').val()

		window.location.href = $(this).attr('href') + '?category=' + category
	})

	// bug fix to allow users to select radio buttons in forms
	$('body .gform_wrapper').on('click', '.gfield_radio li label', function () {
		$(this).prev('input:radio').prop('checked', true).trigger('change')
	})

	// Advanced Search
	$('.search .search__field').autocomplete({
		appendTo: '#search-container',
		source: function (request, response) {
			// Fetch search results
			$.ajax({
				url: ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'efront_advanced_search',
					search: request.term,
				},
				success: function (data) {
					response(data)
				},
			})
		},
		select: function (event, ui) {
			if (ui.item.value.length) {
				window.location.href = ui.item.value
			}

			return false
		},
	})
})(jQuery, window, document)
